import dayjs from 'dayjs'

import { Dot } from '../../components/PeriodTable/mocks'
import {
  ClassifiedOperatoryBlock,
  ContractType,
} from '../../rest/types/Classified'

export function BlockOperatingAidTransformer({
  block,
  t,
}: {
  block: ClassifiedOperatoryBlock
  t: any
}) {
  return {
    ...(block?.speciality?.name && {
      adsTypes: {
        texts: {
          seeLess: t('ads_types_see_less'),
          seeMore: t('ads_types_see_more'),
        },
        items: [
          ...(block?.speciality
            ? [
                {
                  title: t('ads_types_speciality_title'),
                  text: block?.speciality?.name,
                },
              ]
            : []),
        ],
      },
    }),

    adsReplacementDate: {
      title: t('ads_replacement_date_title'),
      ...(block?.startDate && {
        subtitle: {
          label: block?.contract.includes(ContractType.Cdi)
            ? t('ads_replacement_date_employee_subtitle')
            : t('ads_replacement_date_replacement_subtitle'),
          requestedDate: dayjs(block?.startDate).format('DD MMMM YYYY'),
        },
      }),
      periods: {
        label: t('ads_replacement_date_period_label'),
        ...(block?.startDate && {
          start: dayjs(block?.startDate).format('DD MMMM YYYY'),
        }),
        ...(block?.endDate && {
          finish: dayjs(block?.endDate).format('DD MMMM YYYY'),
        }),
      },
      ...(block?.frequency && {
        frequency: {
          label: t('ads_replacement_date_frequency_label'),
          value: t(`ads_replacement_date_frequency_${block?.frequency}`),
        },
      }),
      periodTable: {
        labels: {
          morningRowLabel: t('ads_replacement_date_morning_row_Label'),
          afternoonRowLabel: t('ads_replacement_date_afternoon_row_Label'),
          mondayLabel: t('ads_replacement_date_monday_label'),
          tuesdayLabel: t('ads_replacement_date_tuesday_label'),
          wednesdayLabel: t('ads_replacement_date_wednesday_label'),
          thursdayLabel: t('ads_replacement_date_thursday_label'),
          fridayLabel: t('ads_replacement_date_friday_label'),
          saturdayLabel: t('ads_replacement_date_saturday_label'),
          sundayLabel: t('ads_replacement_date_sunday_label'),
          columnLabel: t('ads_replacement_date_column_label'),
        },
        monday: {
          ...(block?.days?.mondayMorning && {
            morning: <Dot />,
          }),
          ...(block?.days?.mondayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        tuesday: {
          ...(block?.days?.tuesdayMorning && {
            morning: <Dot />,
          }),
          ...(block?.days?.tuesdayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        wednesday: {
          ...(block?.days?.wednesdayMorning && {
            morning: <Dot />,
          }),
          ...(block?.days?.wednesdayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        thursday: {
          ...(block?.days?.thursdayMorning && {
            morning: <Dot />,
          }),
          ...(block?.days?.thursdayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        friday: {
          ...(block?.days?.fridayMorning && {
            morning: <Dot />,
          }),
          ...(block?.days?.fridayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        saturday: {
          ...(block?.days?.saturdayMorning && {
            morning: <Dot />,
          }),
          ...(block?.days?.saturdayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        sunday: {
          ...(block?.days?.sundayMorning && {
            morning: <Dot />,
          }),
          ...(block?.days?.sundayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        withGrid: true,
      },
    },
    adsDetails: {
      items: [
        ...(block?.contract?.length
          ? [
              {
                label: t('ads_details_contract_type_title'),
                values: block?.contract?.map((item) =>
                  t(`ads_details_contract_type_${item}`)
                ),
              },
            ]
          : []),
      ],
    },
  }
}
